import { boxShadows } from '@eversports/design-tokens/box-shadows'
import { Table, TableContainer } from '@eversports/klimt-primitives/legacy/Table'

import { Invoice } from '../InvoiceHistory.types'

import TableContent from './TableContent'
import TableHeader from './TableHeader'

interface Props {
  invoices: Array<Invoice>
}

const InvoiceTable = ({ invoices }: Props) => {
  return (
    <TableContainer sx={{ boxShadow: boxShadows.default, display: { xs: 'none', md: 'block' } }}>
      <Table>
        <TableHeader />
        <TableContent invoices={invoices} />
      </Table>
    </TableContainer>
  )
}

export default InvoiceTable
